module.exports = __webpack_public_path__ + "static/media/details-look.ae7c4f8e.svg";